import React from "react";
import {
  NotificationDropDownSkelton,
  NotificationEmptyMessage,
  NotificationIndividualItem,
  useNotificationBanner,
} from "..";
import NotificationIcon from "assets/images/notification.svg";
import NoVideoIcon from "assets/images/no_video.png";
import "../styles/notification.styles.css";
import { NotificationsText } from "..";
import { useAppScope } from "master";

export const NotificationDropDown = () => {
  const {
    notificationsBanner,
    viewAllNotification,
    notificationDetails: data,
  } = useNotificationBanner({
    load: true,
    unreadOnly: false,
  });
  const { isLoading } = notificationsBanner;
  const { lanSettings, isMWCD } = useAppScope();

  return (
    <div className={`header-card header-dropdown header-notification`}>
      {isLoading ? (
        <>
          <NotificationDropDownSkelton />
        </>
      ) : (
        <>
          {data?.length > 0 ? (
            <>
              <div className="header-card-header d-flex justify-content-between align-items-center px-4 py-3">
                <h2>
                  {NotificationsText.Notifications[lanSettings?.lan || "en"]}
                </h2>
                <span onClick={viewAllNotification}>
                  {NotificationsText.ViewAll[lanSettings?.lan || "en"]}
                </span>
              </div>
              <div className="header-card-content">
                <ul className="notification-list">
                  {data &&
                    data?.slice(0, 4)?.map((notification, index) => (
                      <span className="link-decoration" key={notification?.key}>
                        <NotificationIndividualItem
                          data={notification}
                          trim={true}
                          viewAllNotification={viewAllNotification}
                        />
                      </span>
                    ))}
                </ul>
              </div>
            </>
          ) : (
            <NotificationEmptyMessage
              heading={isMWCD ? "अद्याप कोणतेही व्हिडिओ रेकॉर्ड केलेले नाहीत!" : "No notifications yet!"}
              subHeading={isMWCD ? "व्हिडिओ रेकॉर्ड झाल्यावर ते येथे दिसतील." : "When you get notifications,they'll show up here."}
              image={isMWCD ? NoVideoIcon : NotificationIcon}
            />
          )}
        </>
      )}
    </div>
  );
};
